import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';

const GenerateReportFilesHeader = props => {
  const {} = props;
  return (
    <div className="entity_header report_files_admin_header">
      <div className='entity_title'>
         <FormattedMessage id="reportFileAdmin.generateTitle"/>
      </div>
    </div>
  );
};

export default GenerateReportFilesHeader;



// WEBPACK FOOTER //
// ./source/client/components/reportFileAdmin/generateReportFilesHeader.jsx